import { AssignmentItem } from "./AssignmentItem";

export class AssignedLibraryAsset extends AssignmentItem
{
    private assetId:number|null;
    
    public constructor() {
        super();
    }

    public get AssetId() {
        return this.assetId;
    }

    public set AssetId(v:number) {
        this.assetId = v;
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/models/AssignedLibraryAsset.ts